var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-profile"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.user.company))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39550ee6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile.vue
// module id = null
// module chunks = 